import { PageOptionContext, PageOptionDispatchContext } from '@/components/dashboard/context';
import { DEFAULT_META_DESCRIPTION } from '@/constants';
import sharedStyles from '@/styles/Shared.module.css';
import { Search } from '@styled-icons/feather';
import { Text } from '@typedream/ui';
import classNames from 'classnames';
import Image from 'next/legacy/image';
import { useContext } from 'react';
import { PagesOptionSEOSettingsProps } from './types';

// SEO Settings:
// title = metatags.title || space.name/page.name || LOGO_NAME
// description = metatags.description || DEFAULT_META_DESCRIPTION

export function PagesOptionSEOSettings({ columns, disabled = false }: PagesOptionSEOSettingsProps) {
  const { page, meta } = useContext(PageOptionContext);
  const { setMeta } = useContext(PageOptionDispatchContext);
  return (
    <div className={classNames({ columns })}>
      <div className={classNames({ column: columns })}>
        <Text as="p" size="md" className="mb-2">
          Meta title
        </Text>
        <input
          className={classNames(sharedStyles.inputMedium)}
          type="text"
          value={meta.title || ''}
          placeholder={page?.name || ''}
          onChange={(e) => setMeta((curr) => ({ ...curr, title: e.target.value }))}
          disabled={disabled}
        />
        <Text as="p" size="2xs" variant="secondary" className="mb-4 !leading-6">
          Recommended: 70 characters. You’ve used{' '}
          <span
            className={classNames({
              'with-text-color': (meta.title?.length || 0) <= 70,
              'with-danger-text-color': (meta.title?.length || 0) > 70,
            })}
          >
            {meta.title?.length || 0}
          </span>
        </Text>

        <Text as="p" size="md" className="mb-2">
          Meta Description
        </Text>
        <textarea
          className={classNames(sharedStyles.inputMedium, '!h-[100px]')}
          value={meta.description || ''}
          placeholder={DEFAULT_META_DESCRIPTION}
          onChange={(e) => setMeta((curr) => ({ ...curr, description: e.target.value }))}
          disabled={disabled}
        />
        <Text as="p" size="2xs" variant="secondary" className="mb-4 !leading-6">
          Recommended: 156 characters. You’ve used{' '}
          <span
            className={classNames({
              'with-text-color': (meta.description?.length || 0) <= 156,
              'with-danger-text-color': (meta.description?.length || 0) > 156,
            })}
          >
            {meta.description?.length || 0}
          </span>
        </Text>
      </div>

      <div className={classNames({ column: columns })}>
        <Text as="p" size="xs" className="mb-2">
          Search Engine Result Preview
        </Text>
        <div
          className="w-full, my-4 mx-0 py-4 px-5 rounded-lg bg-neutral-25"
          style={{ boxShadow: 'var(--shadow-modal)' }}
        >
          <div className="flex items-center ">
            <Image src="/images/google.png" width={60} height={35} />
            <div className="rounded-full flex items-center flex-1 px-4 h-8 ml-2.5 border border-solid border-[#0000001a]text-neutral-900">
              <Search size={15} />
            </div>
          </div>
          <Text as="p" size="xl" className="mt-4 text-[#1a0dab] mb-1">
            {meta.title || page.name}
          </Text>
          <Text as="p" size="sm" className="text-[#4d5156]">
            {meta.description || DEFAULT_META_DESCRIPTION}
          </Text>
        </div>
      </div>
    </div>
  );
}
